import { NgModule } from '@angular/core';
import { ProofOfDeliveryBaseComponent } from './proof-of-delivery-base.component';
import { IntrackFeatureModule } from '../../intrack-feature.module';
import { TranslateModule } from '@ngx-translate/core';
import { ActionButtonModule } from '../action-button';
import { SvgIconModule } from '../svg-icon/svg-icon.module';

@NgModule({
  declarations: [ProofOfDeliveryBaseComponent],
  imports: [IntrackFeatureModule, ActionButtonModule, TranslateModule.forChild({}), SvgIconModule],
  exports: [ProofOfDeliveryBaseComponent],
})
export class ProofOfDeliveryBaseModule {}
